import { render, staticRenderFns } from "./ItemPending.vue?vue&type=template&id=ff8bad2a&"
import script from "./ItemPending.vue?vue&type=script&lang=ts&"
export * from "./ItemPending.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports